// @flow

import React from 'react';
import {
  Modal,
  Button,
  Loader,
  Dropdown,
  Form,
  Dimmer,
} from 'semantic-ui-react';
import * as UsersAPI from '../../api/users';
import * as ThreadsAPI from '../../api/threads';
import type { Thread } from '../../types';

type User = {
  id: Number,
  name: String,
};

type Props = {
  open: boolean,
  onCreated: (thread: Thread) => void,
  onClose: () => void,
};

type State = {
  loading: boolean,
  creating: boolean,
  users: User[],
  selectedUser?: number,
};

export class CreateThreadModal extends React.Component<Props, State> {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
      creating: false,
      users: [],
    };
  }

  onOpen = () => {
    // Fetching users
    this.setState({
      loading: true,
    });

    UsersAPI.fetchUsers().then(users =>
      this.setState({
        loading: false,
        users,
      })
    );
  };

  onClose = () => {
    this.setState({
      loading: false,
      creating: false,
      users: [],
      selectedUser: undefined,
    });

    this.props.onClose();
  };

  onChangeUser = (_, { value }) =>
    this.setState({
      selectedUser: value,
    });

  onCreate = () => {
    const { selectedUser } = this.state;
    if (selectedUser != null) {
      this.setState({
        creating: true,
      });

      ThreadsAPI.createThread({
        user: selectedUser,
      }).then(thread => {
        this.props.onCreated(thread);
      });
    }
  };

  render() {
    const { open } = this.props;
    const { loading, creating, users, selectedUser } = this.state;

    const usersOptions = users.map(user => ({
      key: user.id.toString(),
      value: user.id.toString(),
      text: user.name,
    }));

    return (
      <Modal
        open={open}
        onMount={this.onOpen}
        onUnmount={this.onClose}
        onClose={this.onClose}
        closeIcon
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        size="small"
      >
        <Modal.Header>Nouvelle conversation</Modal.Header>
        <Modal.Content>
          <Dimmer active={loading} inverted>
            <Loader active={loading} inline="centered" />
          </Dimmer>
          <div className="ui form">
            <Form.Field>
              <label>Sélectionnez un utilisateur</label>
              <Dropdown
                fluid
                search
                selection
                options={usersOptions}
                onChange={this.onChangeUser}
                value={selectedUser}
                noResultsMessage="Aucun partenaire sans conversation trouvé"
              />
            </Form.Field>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.onClose}
            labelPosition="left"
            icon="close"
            content="Annuler"
          />
          <Button
            positive
            labelPosition="right"
            icon="save"
            content="Créer"
            disabled={creating || loading || !selectedUser}
            onClick={this.onCreate}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/components/threads/CreateThreadModal.js